import NoDataFoundImage from "../../assets/img/empty-box.png";
import classNames from "classnames";

const NoDataFound = ({ type = "Data", customClass }: any) => {
  return (
    <div
      className={classNames("d-flex justify-content-center h-100", customClass)}
    >
      <div className="text-container text-center text-xl-start d-flex flex-column align-items-center">
        <img
          src={NoDataFoundImage}
          alt="Kiros Iq"
          width={250}
          className="mb-4"
        />
        <h2 className="text-body-secondary fs-xl-6 mb-3">No {type} Found</h2>
      </div>
    </div>
  );
};

export default NoDataFound;
